/**
 * Fade in the footer illustration when user scrolls almost to the bottom.
 */
export function initFooterIllustration() {
  const el = document.querySelector(".c-site-footer__illustration");
  if (!el) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        }
      });
    },
    {
      rootMargin: "0px 0px 80px 0px",
      threshold: 0,
    }
  );

  observer.observe(el);
}

/**
 * Reset illustration visibility (e.g. after page transition so it can fade in again).
 */
export function resetFooterIllustration() {
  const el = document.querySelector(".c-site-footer__illustration");
  if (el) el.classList.remove("is-visible");
}
